/**
 * 방 라벨 앞에 ordinal prefix("1번")가 두 번 누출된 경우 한 번만 남기도록 정정한다.
 *
 * 사용처: `MovingItemsFlowAdapter`가 호출 측(`RoomObservingFlowAdapter` 등)에서
 * 받은 `roomLabel` 을 그대로 헤더 타이틀("${roomLabel}에서 가져가실 짐을…")로
 * 사용하기 전에 한 번 더 정제한다.
 *
 * 배경: 과거 house-sketch flow 매퍼 버그로 namePrefix 에 "1번 방" 같은 ordinal 이
 * 새어 들어간 적이 있고, backend 가 displayLabel 을 `${ordinal}번${namePrefix}` 로
 * 만들면서 "1번1번 방" 형태가 굳어진 데이터가 존재한다. sketch room 라벨 단계
 * (`formatSketchingRoomLabelSpaced`)에서 한 번 정정하지만, 세션의 `displayLabel`을
 * 그대로 노출하는 경로(`resolveRoomObservingDisplayLabelSpaced` 등)에서는 정정이
 * 빠질 수 있어 마지막 표시 단에서 한 번 더 정제하는 안전망을 둔다.
 *
 * 다른 worker 가 sketch 라벨 코드(formatSketchingRoomLabelSpaced 등)를
 * 정리 중이므로, 본 헬퍼는 호출 측 라벨을 신뢰한 채 표면적인 중복 패턴만
 * 제거하는 멱등 함수로 유지한다 — 호출 측이 이미 정상 라벨을 만들면 입력을
 * 그대로 통과시킨다.
 *
 * 정정 규칙:
 *   - "1번1번 방" → "1번 방"
 *   - "1번 1번 방" → "1번 방"
 *   - "1번1번방" → "1번방"
 *   - "1번 방" → "1번 방" (변경 없음)
 *   - 빈 문자열 → "" (변경 없음)
 *   - 숫자가 다른 경우(예: "1번2번 방") → 변경 없음 (의도된 합성으로 간주)
 */
export function dedupeOrdinalPrefix(label: string): string {
  // `^(\d+번)\s*\1` 매칭 시 두 번째 ordinal 만 제거 — 첫 번째 매치가 동일 숫자일 때만.
  return label.replace(/^(\d+번)\s*\1/, '$1');
}
